import React from "react";
import { Fab, Tooltip } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";

interface SrAgentFabProps {
    onClick: () => void;
}

export const SrAgentFab: React.FC<SrAgentFabProps> = ({ onClick }) => {
    return (
        <Tooltip title="SR Assistant" placement="left">
            <Fab
                aria-label="open sr agent chat"
                onClick={onClick}
                sx={{
                    position: "fixed",
                    bottom: 96,
                    right: 24,
                    zIndex: 40,
                    backgroundColor: "#0F172A",
                    color: "#fff",
                    "&:hover": {
                        backgroundColor: "#1E293B",
                        transform: "scale(1.06)",
                    },
                    transition: "transform 0.2s ease, background-color 0.2s ease",
                    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.28)",
                }}
            >
                <ChatBubbleOutlineIcon />
            </Fab>
        </Tooltip>
    );
};
